import styled from "styled-components";

export const NavigationWrapper = styled.div`
    .Backdrop-Navigation {
        z-index: 2;
    }

    .Navigation-primary {
        z-index: 2;
    }
`;
